import { mixed } from 'yup'
import { safify } from '../utils/safify'

export const project = mixed()
  .meta({ hide: false, autoFill: true, label: 'Name your doc and select a location', placeholder: 'Name your doc...' })
  .transform(safify)
